import { SET_USER_LICENSING_AGREEMENT_STATE } from "constants-lib/actionTypes"

export const setUserLicensingAgreementState = (payload) => ({
  type: SET_USER_LICENSING_AGREEMENT_STATE,
  payload,
})
